// ============================================================================
// BreadcrumbService - Page-Set Breadcrumb Trail
// ============================================================================
// Each page component calls set([{text, url?}, ...]) in ngOnInit (or after
// data loads for dynamic labels). The shell renders these via BreadcrumbComponent.
// Auto-clears on NavigationStart so a stale trail never flashes before the
// next page sets its own.
// ============================================================================

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface BreadcrumbItem {
  text: string;
  url?: string;
}

@Injectable()
export class BreadcrumbService {
  private itemsSubj = new BehaviorSubject<BreadcrumbItem[]>([]);
  items$ = this.itemsSubj.asObservable();

  constructor(router: Router) {
    router.events
      .pipe(filter(e => e instanceof NavigationStart))
      .subscribe(() => this.clear());
  }

  set(items: BreadcrumbItem[]): void {
    this.itemsSubj.next(items);
  }

  clear(): void {
    this.itemsSubj.next([]);
  }
}
